import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { AuthorizationProperties } from 'src/app/authentication/auth-info';
import { CmsService } from 'src/app/core/services/cms.service';
import { CustomerService } from 'src/app/core/services/customer.service';
import { LoginService } from 'src/app/core/services/login.service';
import { VerticalSolutionsService } from 'src/app/core/services/verticalsolutions.service';
import { WorkFlowService } from 'src/app/core/services/work-flow.service';
import { CmsObject } from 'src/app/model/cmsobject';
import { OperationResult } from '@tb/auth';
import { VerticalProduct } from 'src/app/model/ProductDto';
import { LoadingService } from 'src/app/core/services/loading.service';
import { HttpEventType, HttpResponse } from '@angular/common/http';
import { ProgressStatus, ProgressStatusEnum } from 'src/app/model/progress-status';
import { TranslatedVariables } from 'src/app/commons/translated-variables';
import { ProxyService } from 'src/app/core/services/proxy.service';

@Component({
    selector: 'ms-crypt-sales-modules',
    templateUrl: './crypt-sales-modules.component.html',
    styleUrls: ['./crypt-sales-modules.component.scss'],
})
export class CryptSalesModulesComponent implements OnInit {
    public introduction: string;
    public cmsObj: CmsObject[];
    public cryptSalesModuleIntroduction: string;
    uploadedFiles: File[] = [];
    fileName = '';
    requiredFileType: string;
    uploadProgress: number;
    uploadSub: Subscription;
    noItems: boolean = true;
    noSolutions: boolean = true;
    messageBoxMessage: string = '';
    isError: boolean = false;
    cryptButtonVisible: boolean = false;
    uploadButtonVisible: boolean = false;
    //disableDownloadButton: boolean = true;
    tableFilesVisible: boolean = false;
    //showMessage: boolean = false;
    authorizationStored;
    authorizationProperties: AuthorizationProperties;
    signature: string;
    verticalSolutionList: VerticalProduct[] = [];
    loading: boolean = false;
    guid: string;
    selectedValue: string;

    constructor(
        private cmsService: CmsService,
        private workFlow: WorkFlowService,
        private verticalSolutionService: VerticalSolutionsService,
        private loginService: LoginService,
        private customerService: CustomerService,
        public loadingService: LoadingService,
        private translatedVariable: TranslatedVariables,
        private proxyService: ProxyService
    ) {}

    async ngOnInit() {
        await this.getCmsObj();
        //BindData
        this.customerService.companyInfo$.subscribe(async (companyInfo) => {
            if (!companyInfo) return;
            this.loading = true;
            this.loadingService.setLoading(this.loading);
            await this.BindData();
            this.loading = false;
            this.loadingService.setLoading(this.loading);
        });
    }

    private async BindData() {
        this.authorizationStored = this.loginService.getauthinfo();
        this.authorizationProperties = JSON.parse(this.authorizationStored);
        let result: OperationResult = await this.verticalSolutionService.getAllProductsByReseller(
            this.verticalSolutionService.currentCodiceAzienda,
            true,
            false
        );
        if (result.Result) {
            this.verticalSolutionList = result.Content as VerticalProduct[];
            this.noSolutions = this.verticalSolutionList.length<=0;
        }
    }

    async getCmsObj() {
        //recupero le stringhe della pagina
        this.cmsObj = await this.cmsService.getCmsObj(this.workFlow.getLanguageForCms(), 'vs_cryptsalesmodules');
        this.cryptSalesModuleIntroduction = this.cmsObj.find(
            (x) => x.ContentName == 'vs_cryptsalesmodules.introduction'
        ).ContentTranslation;
    }
    onFileSelected(event) {
        this.uploadedFiles = event.target.files;
        this.noItems = this.uploadedFiles.length == 0;
        let files: File[] = [];
        for (let i = 0; i < this.uploadedFiles.length; i++) {
            let file = this.uploadedFiles[i];
            if (file) {
                let fileExtension = file.name.split('.').pop();
                if (fileExtension != 'xml') {
                    this.workFlow.showSnackBar(this.translatedVariable.invalidCryptingFilesExtension);
                } else files.push(file);
                this.fileName = this.fileName + ';' + file.name;
            }
        }
        this.uploadedFiles = Object.assign(files);
        this.setDisabled();

        this.tableFilesVisible = this.uploadedFiles.length > 0;
        this.cryptButtonVisible = this.uploadedFiles.length > 0;
    }
    delete(file: File) {
        let files: File[] = [];
        for (let i = 0; i < this.uploadedFiles.length; i++) {
            let f = this.uploadedFiles[i];
            if (file.name === f.name) continue;
            files.push(f);
        }
        if (files.length == 0) this.uploadedFiles = [];
        else this.uploadedFiles = Object.assign(files);
    }
    async crypt() {
        this.authorizationStored = this.loginService.getauthinfo();
        this.authorizationProperties = JSON.parse(this.authorizationStored);
        this.guid = this.getGuid();
        this.loading = true;
        this.loadingService.setLoading(this.loading);
        //prima controllo i file su redis
        let checkResult: OperationResult = await this.proxyService.checkFiles(this.uploadedFiles);
        if (checkResult.Result) {
            console.log('crypt - signature - guid', this.signature, this.guid);
            let opResult = await this.verticalSolutionService.CryptFiles(
                this.uploadedFiles,
                this.authorizationProperties.accountName,
                this.signature,
                this.guid
            );
            if (opResult.Result) {
                this.download();
                this.workFlow.showSnackBar(this.translatedVariable.cryptGenerationOk);
            }

            this.uploadButtonVisible = false;
            this.cryptButtonVisible = false;
            this.tableFilesVisible = false;
            this.messageBoxMessage = opResult.Message;
            this.isError = !opResult.Result;
            this.loading = false;
            this.loadingService.setLoading(this.loading);
        } else {
            this.messageBoxMessage = checkResult.Message;
            this.isError = !checkResult.Result;
            this.loading = false;
            this.loadingService.setLoading(this.loading);
        }
    }
    padTwoDigits(num: number) {
        return num.toString().padStart(2, '0');
    }

    getGuid() {
        let date = new Date();
        return date
            .getFullYear()
            .toString()
            .concat(
                this.padTwoDigits(date.getMonth() + 1),
                this.padTwoDigits(date.getDate()),
                this.padTwoDigits(date.getHours()),
                this.padTwoDigits(date.getMinutes()),
                this.padTwoDigits(date.getSeconds())
            );
    }

    setDisabled() {
        return this.uploadedFiles.length == 0 || !this.selectedValue || this.selectedValue == 'none';
    }
    public onSolutionChange(event: any) {
        this.uploadButtonVisible = event.value != 'none';
        this.signature = event.value;
        this.cryptButtonVisible = false;
        this.tableFilesVisible = false;
    }

    private download() {
        this.authorizationStored = this.loginService.getauthinfo();
        this.authorizationProperties = JSON.parse(this.authorizationStored);
        console.log('crypt - signature - guid', this.signature, this.guid);
        this.verticalSolutionService
            .downloadFile(this.authorizationProperties.accountName, this.signature, this.guid)
            .subscribe(async (response) => {
                switch (response.type) {
                    case HttpEventType.Response:
                        this.uploadedFiles = [];
                        this.selectedValue = 'none';
                        this.isError = false;
                        // this.disableDownloadButton = true;
                        this.downloadFile(response, this.signature);
                        this.verticalSolutionService.deleteFile(this.authorizationProperties.accountName, this.signature, this.guid);
                        break;
                }
            });
    }

    downloadFile(data: HttpResponse<Blob>, signature: string) {
        const downloadedFile = new Blob([data.body], { type: data.body.type });
        const a = document.createElement('a');
        a.setAttribute('style', 'display:none;');
        document.body.appendChild(a);
        a.download = signature + '.zip';
        let url = URL.createObjectURL(downloadedFile);
        a.href = url;
        a.target = '_blank';
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
    }
}
